import React from 'react';
import { PapiDeviation } from '@wix/da-papi-types';

import { getDeviationType } from '../../DeviationViews/_helpers';
import { DeviationTypes } from '../../types/deviation';

import ImageView from './Image';
import UnknownView from './Unknown';
import JournalView from './Journal';
import StatusView from './Status';
import LiteratureView from './Literature';
import TierView from './Tier';
import CommissionView from './Commission';

export interface Props {
  deviation: PapiDeviation;
  width?: number;
  height?: number;
  useCoverMode?: boolean;
  allowPreviewUsage?: boolean;
  noCropping?: boolean;
}

const ThumbView: React.FC<Props> = props => {
  let View;
  switch (getDeviationType(props.deviation)) {
    // these types all have guaranteed thumb image
    case DeviationTypes.IMAGE:
    case DeviationTypes.PDF:
    case DeviationTypes.FILM:
      View = ImageView;
      break;
    case DeviationTypes.LITERATURE:
      View = LiteratureView;
      break;
    case DeviationTypes.STATUS:
      View = StatusView;
      break;
    case DeviationTypes.JOURNAL:
      View = JournalView;
      break;
    case DeviationTypes.TIER:
      View = TierView;
      break;
    case DeviationTypes.COMMISSION:
      View = CommissionView;
      break;
    default:
      View = UnknownView;
  }
  return <View {...props} />;
};
ThumbView.displayName = 'ThumbView';

export default ThumbView;
